$(function(){


    if($(".trim-record").length != 0 ){
        $(".data-cell").each(function () {
            if($(this).html().trim() == ""){
                $(this).addClass('no-value');
            }
            if($(this).find('.document-link-container').length  != 0){
                if($(this).find('.document-link-container').html().trim() == ''){
                    $(this).addClass('no-value');
                }
            }
        });
        $(".model-row").each(function(){
            var rid = $(this).attr('rid');
            if($('.data-cell[rid="' + rid + '"]').length == $('.no-value[rid="' + rid + '"]').length){
                $(this).remove();
            }
        });

        $('.range-row').each(function () {
            var cid = $(this).attr('cid');
            if($('.model-row[cid="' + cid + '"]:visible').length == 0){
                $(this).remove();
            }
        })
    }

});


